import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';

import messages from 'aurora-translations';
import ADGMTextField from '../../ADGMTextField';
import ADGMSelect from '../../ADGMSelect';
import styles from './styles';

function SearchFilters(props) {
  const { classes, intl, loading, formData, handleChange, handleSelectChange, handleResetForm, dropdownData } = props;

  const getFieldMask = (mask = '') => Array.from(mask).map(item => (item === '#' ? /\d/ : item));

  return (
    <div>
      <div className={classes.filtersWrapper}>
        <div className={classes.filtersMenu}>
          <>
            <ADGMTextField
              id='passportNumber'
              name='passportNumber'
              value={formData.passportNumber}
              placeholder={intl.formatMessage({ ...messages.Passport_number })}
              onChange={handleChange}
              customClasses={{ field: classes.textField, input: classes.nonUAEInput }}
            />

            <ADGMSelect
              id='nationalityId'
              name='nationalityId'
              type='select'
              search
              placeholder={intl.formatMessage({ ...messages.Nationality })}
              value={
                isEmpty(formData.passportNumber)
                  ? null
                  : dropdownData.filter(dt => dt.value === formData.nationalityId?.value)
              }
              onChange={handleSelectChange}
              options={dropdownData}
              customClasses={{ select: classes.selectBox }}
              disabled={isEmpty(formData.passportNumber)}
            />
            <ADGMTextField
              id='email'
              name='email'
              value={formData.email}
              placeholder={intl.formatMessage({ ...messages.Email })}
              onChange={handleChange}
              customClasses={{ field: classes.textField, input: classes.nonUAEInput }}
            />
            <ADGMTextField
              id='mobileNumber'
              name='mobileNumber'
              value={formData.mobileNumber}
              placeholder={intl.formatMessage({ ...messages.mobile })}
              onChange={handleChange}
              customClasses={{ field: classes.textField, input: classes.nonUAEInput }}
              mask={getFieldMask('### ## ### ####')}
            />
          </>
        </div>
      </div>
      {/* Below form fields */}
      <div className={classes.searchBtnContainer}>
        <Button className={classes.resetBtn} onClick={handleResetForm} type='reset' disabled={loading}>
          <FormattedMessage {...messages.reset_filters} />
        </Button>
        <Button variant='contained' color='primary' type='submit' disabled={loading} className={classes.searchBtn}>
          <FormattedMessage {...messages.search} />
        </Button>
      </div>
    </div>
  );
}

SearchFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  handleResetForm: PropTypes.func.isRequired,
  dropdownData: PropTypes.array,
};

SearchFilters.defaultProps = {
  loading: false,
  dropdownData: [],
};

export default withStyles(styles)(memo(SearchFilters));
